/* ==========================================================================
   MYHOLDAL - Size guide
   Reads the JSON in snippets/size-guide-data.liquid and renders the charts
   into either the product page modal or the standalone size guide page.
   No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var DATA = null;

  function getData() {
    if (DATA) return DATA;
    var el = document.getElementById('SizeGuideData');
    if (!el) return null;
    try {
      DATA = JSON.parse(el.textContent);
    } catch (e) {
      DATA = null;
    }
    return DATA;
  }

  function getBrand(key) {
    var data = getData();
    if (!data) return null;
    for (var i = 0; i < data.brands.length; i++) {
      if (data.brands[i].key === key) return data.brands[i];
    }
    return null;
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- Matching the shopper's selected size ------------------------------ */

  // "EU 40 - UK 6.5" -> ["eu", "40", "uk", "6.5"]
  function tokenize(value) {
    return String(value || '')
      .toLowerCase()
      .split(/[^a-z0-9.]+/)
      .filter(function (t) {
        return t !== '' && t !== 'eu' && t !== 'uk' && t !== 'us' && t !== 'fr';
      });
  }

  function normalCell(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/^(eu|uk|us)\s*:?\s*/, '')
      .trim();
  }

  // Every spelling of a size cell worth comparing against a variant value.
  // "XS-S" also has to match the option value "XSS", and "M-L" has to match
  // "ML", which is how Bimba y Lola names them on this store.
  function cellKeys(cell) {
    var value = normalCell(cell);
    if (!value) return [];
    var keys = [value];
    var joined = value.replace(/[-\s]/g, '');
    if (joined && joined !== value) keys.push(joined);
    if (value.indexOf('-') !== -1) {
      value.split('-').forEach(function (part) {
        part = part.trim();
        if (part) keys.push(part);
      });
    }
    return keys;
  }

  // Returns the index of the column that best matches the selected size, or -1.
  function matchColumn(chart, selected) {
    var tokens = tokenize(selected);
    if (!tokens.length) return -1;

    var scores = [];
    var i;
    var count = chart.head[0].values.length;
    for (i = 0; i < count; i++) scores.push(0);

    chart.head.forEach(function (row, rowIndex) {
      // Earlier header rows are the more authoritative sizing systems.
      var weight = rowIndex === 0 ? 3 : rowIndex === 1 ? 2 : 1;
      row.values.forEach(function (cell, colIndex) {
        var hit = cellKeys(cell).some(function (key) {
          return tokens.indexOf(key) !== -1;
        });
        if (hit) scores[colIndex] += weight;
      });
    });

    var best = -1;
    var bestScore = 0;
    for (i = 0; i < scores.length; i++) {
      if (scores[i] > bestScore) {
        bestScore = scores[i];
        best = i;
      }
    }
    return best;
  }

  // How well a chart covers a whole set of size values, e.g. every size a
  // product is sold in. Used to pick between charts that a product type alone
  // cannot separate: Lacoste sport shorts are sized 2-11 like tops, while
  // chino shorts are sized 34-56 like trousers.
  function chartScore(chart, values) {
    var known = {};
    chart.head.forEach(function (row) {
      row.values.forEach(function (cell) {
        cellKeys(cell).forEach(function (key) {
          known[key] = true;
        });
      });
    });

    var score = 0;
    values.forEach(function (value) {
      tokenize(value).forEach(function (token) {
        if (known[token]) score += 1;
      });
    });
    return score;
  }

  function pickBestChart(brand, chartIds, values) {
    var best = chartIds[0];
    var bestScore = -1;
    chartIds.forEach(function (chartId) {
      var chart = brand.charts[chartId];
      if (!chart) return;
      var score = chartScore(chart, values);
      if (score > bestScore) {
        bestScore = score;
        best = chartId;
      }
    });
    return best;
  }

  /* --- Rendering --------------------------------------------------------- */

  function chartHTML(brand, chartId, options) {
    var data = getData();
    var chart = brand.charts[chartId];
    if (!chart) return '';
    options = options || {};

    var current = options.selected ? matchColumn(chart, options.selected) : -1;
    var html = '<div class="mh-sg__chart">';
    html += '<h3 class="mh-sg__chart-title">' + esc(chart.title) + '</h3>';
    if (chart['for']) html += '<p class="mh-sg__chart-for">' + esc(chart['for']) + '</p>';

    html += '<div class="mh-sg__tablewrap"><table class="mh-sg__table"><tbody>';

    chart.head.forEach(function (row) {
      html += '<tr class="mh-sg__hrow"><th scope="row">' + esc(row.label) + '</th>';
      row.values.forEach(function (value, index) {
        html += '<td' + (index === current ? ' class="is-current"' : '') + '>' + esc(value) + '</td>';
      });
      html += '</tr>';
    });

    chart.rows.forEach(function (row) {
      var measure = data.measures[row.key] || { label: row.key };
      // Most metric figures are centimetres; ring diameters are millimetres.
      var metricUnit = row.metricUnit || 'cm';
      html +=
        '<tr><th scope="row">' +
        esc(measure.label) +
        ' <span class="mh-sg-u-cm">(' + esc(metricUnit) + ')</span><span class="mh-sg-u-in">(in)</span></th>';
      row.cm.forEach(function (value, index) {
        html +=
          '<td' +
          (index === current ? ' class="is-current"' : '') +
          '><span class="mh-sg-u-cm">' +
          esc(value) +
          '</span><span class="mh-sg-u-in">' +
          esc(row['in'][index]) +
          '</span></td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';

    if (current > -1 && options.selected) {
      html +=
        '<p class="mh-sg__yoursize">Highlighted: the column matching the size you selected &mdash; <b>' +
        esc(options.selected) +
        '</b>.</p>';
    }

    // How to take each measurement
    html += '<div class="mh-sg__measure"><h4>How to measure</h4><ul>';
    chart.rows.forEach(function (row) {
      var measure = data.measures[row.key] || { label: row.key, how: '' };
      html += '<li><b>' + esc(measure.label) + '</b><span>' + esc(measure.how) + '</span></li>';
    });
    html += '</ul></div>';

    html += '</div>';
    return html;
  }

  /* --- Panels + controls -------------------------------------------------- */

  // The unit toggle is re-rendered whenever panels change, so it has to reflect
  // the unit already in force rather than defaulting back to CM.
  function unitButtonsHTML(root) {
    var unit = (root && root.getAttribute('data-unit')) === 'in' ? 'in' : 'cm';
    return (
      '<div class="mh-sg__unit" role="group" aria-label="Units">' +
      '<button type="button" data-unit="cm" aria-pressed="' + (unit === 'cm') + '">CM</button>' +
      '<button type="button" data-unit="in" aria-pressed="' + (unit === 'in') + '">INCH</button>' +
      '</div>'
    );
  }

  // A chart may override the modal's standard opening line. Only the chart on
  // show can speak, so this re-runs whenever the visible panel changes.
  function syncIntro(container, brand) {
    var root = container.closest('.mh-sg') || container;
    var intro = root.querySelector('.mh-sg__intro');
    if (!intro) return;
    if (!intro.hasAttribute('data-default')) intro.setAttribute('data-default', intro.textContent.trim());

    var panel = container.querySelector('.mh-sg__panel:not([hidden])') || container.querySelector('.mh-sg__panel');
    var chart = panel && brand.charts[panel.getAttribute('data-chart')];
    intro.textContent = (chart && chart.intro) || intro.getAttribute('data-default');
  }

  function renderPanels(container, brand, chartIds, options) {
    options = options || {};
    var tabsHTML = '';
    var panelsHTML = '';

    chartIds.forEach(function (chartId, index) {
      var chart = brand.charts[chartId];
      if (!chart) return;
      var id = 'mh-sg-panel-' + chartId + '-' + Math.random().toString(36).slice(2, 7);
      tabsHTML +=
        '<button type="button" class="mh-sg__tab" role="tab" aria-selected="' +
        (index === 0 ? 'true' : 'false') +
        '" data-panel="' +
        id +
        '">' +
        esc(chart.title) +
        '</button>';
      panelsHTML +=
        '<div class="mh-sg__panel" id="' +
        id +
        '" role="tabpanel" data-chart="' +
        esc(chartId) +
        '"' +
        (index === 0 ? '' : ' hidden') +
        '>' +
        chartHTML(brand, chartId, options) +
        '</div>';
    });

    container.innerHTML =
      '<div class="mh-sg__controls">' +
      (chartIds.length > 1 ? '<div class="mh-sg__tabs" role="tablist">' + tabsHTML + '</div>' : '<span></span>') +
      unitButtonsHTML(container.closest('.mh-sg')) +
      '</div>' +
      panelsHTML;

    container.__brand = brand;
    bindControls(container);
    syncIntro(container, brand);
  }

  function bindControls(container) {
    var root = container.closest('.mh-sg') || container;
    if (container.__bound) return;
    container.__bound = true;

    container.addEventListener('click', function (event) {
      var unitButton = event.target.closest('[data-unit]');
      if (unitButton) {
        root.setAttribute('data-unit', unitButton.getAttribute('data-unit'));
        container.querySelectorAll('[data-unit]').forEach(function (button) {
          button.setAttribute('aria-pressed', button === unitButton ? 'true' : 'false');
        });
        return;
      }

      var tab = event.target.closest('.mh-sg__tab');
      if (tab) {
        container.querySelectorAll('.mh-sg__tab').forEach(function (other) {
          other.setAttribute('aria-selected', other === tab ? 'true' : 'false');
        });
        container.querySelectorAll('.mh-sg__panel').forEach(function (panel) {
          panel.hidden = panel.id !== tab.getAttribute('data-panel');
        });
        if (container.__brand) syncIntro(container, container.__brand);
      }
    });
  }

  /* --- Product page modal ------------------------------------------------- */

  // Reads the size option off the product form: the value the shopper has
  // selected, plus every value the product is sold in.
  function sizesFor(trigger) {
    var scope = trigger.closest('[data-section-type="product"]') || document;
    var optionName = (trigger.getAttribute('data-size-option') || 'size').toLowerCase();
    var inputs = scope.querySelectorAll('[data-variant-input]');
    var result = { selected: '', all: [] };
    var i;
    var j;

    for (i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var name = (input.getAttribute('name') || '').toLowerCase();
      if (name.indexOf(optionName) === -1) continue;

      if (input.tagName === 'SELECT') {
        for (j = 0; j < input.options.length; j++) result.all.push(input.options[j].value);
        if (!result.selected) result.selected = input.value;
      } else {
        result.all.push(input.value);
        if (input.checked && !result.selected) result.selected = input.value;
      }
    }
    return result;
  }

  var openModal = null;

  function closeModal() {
    if (!openModal) return;
    openModal.classList.remove('is-open');
    document.documentElement.classList.remove('mh-sg-locked');
    if (openModal.__trigger) openModal.__trigger.focus();
    openModal = null;
  }

  function onTriggerClick(event) {
    var trigger = event.target.closest('[data-mh-sg-open]');
    if (!trigger) return;
    event.preventDefault();

    var modal = document.getElementById(trigger.getAttribute('data-mh-sg-open'));
    if (!modal) return;

    var brand = getBrand(modal.getAttribute('data-brand'));
    if (!brand) return;

    var raw = modal.getAttribute('data-charts') || '';
    var isAuto = raw.indexOf('auto:') === 0;
    var chartIds = raw.replace(/^auto:/, '').split(',').filter(Boolean);
    var sizes = sizesFor(trigger);

    // "auto:" means the candidates are alternatives for the same garment, so
    // show only the one that actually matches how this product is sized.
    if (isAuto && chartIds.length > 1) {
      chartIds = [pickBestChart(brand, chartIds, sizes.all)];
    }

    var body = modal.querySelector('[data-mh-sg-panels]');
    renderPanels(body, brand, chartIds, { selected: sizes.selected });

    modal.classList.add('is-open');
    document.documentElement.classList.add('mh-sg-locked');
    modal.__trigger = trigger;
    openModal = modal;

    var closeButton = modal.querySelector('.mh-sg-modal__close');
    if (closeButton) closeButton.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mh-sg-open]')) {
      onTriggerClick(event);
      return;
    }
    if (event.target.closest('[data-mh-sg-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openModal) closeModal();
  });

  /* --- Standalone page ---------------------------------------------------- */

  function initPage() {
    document.querySelectorAll('[data-mh-sg-page]').forEach(function (page) {
      var data = getData();
      if (!data) return;

      var wanted = (page.getAttribute('data-brands') || '')
        .split(',')
        .map(function (key) {
          return key.trim().toLowerCase();
        })
        .filter(Boolean);

      var brands = data.brands.filter(function (candidate) {
        return !wanted.length || wanted.indexOf(candidate.key) !== -1;
      });
      if (!brands.length) return;

      var brand = brands[0];
      var brandBar = page.querySelector('[data-mh-sg-brands]');
      var groupBar = page.querySelector('[data-mh-sg-groups]');
      var panels = page.querySelector('[data-mh-sg-panels]');
      var intro = page.querySelector('[data-mh-sg-intro]');

      function show(groupKey) {
        var group = brand.groups.filter(function (candidate) {
          return candidate.key === groupKey;
        })[0];
        if (!group) return;

        var html = '';
        group.charts.forEach(function (chartId) {
          html += chartHTML(brand, chartId, {});
        });
        panels.innerHTML =
          '<div class="mh-sg__controls">' +
          '<span class="mh-sg__eyebrow">' +
          esc(brand.name) +
          ' &mdash; ' +
          esc(group.label) +
          '</span>' +
          unitButtonsHTML(page) +
          '</div>' +
          html;

        panels.__brand = brand;
        bindControls(panels);

        groupBar.querySelectorAll('.mh-sg__tab').forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.getAttribute('data-group') === groupKey ? 'true' : 'false');
        });
      }

      function showBrand(nextBrand) {
        brand = nextBrand;
        if (intro) intro.textContent = brand.intro || '';
        groupBar.innerHTML = brand.groups
          .map(function (group, index) {
            return (
              '<button type="button" class="mh-sg__tab" data-group="' +
              esc(group.key) +
              '" aria-selected="' +
              (index === 0 ? 'true' : 'false') +
              '">' +
              esc(group.label) +
              '</button>'
            );
          })
          .join('');
        if (brandBar) {
          brandBar.querySelectorAll('[data-brand-key]').forEach(function (tab) {
            tab.setAttribute('aria-selected', tab.getAttribute('data-brand-key') === brand.key ? 'true' : 'false');
          });
        }
        show(brand.groups[0].key);
      }

      groupBar.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-group]');
        if (tab) show(tab.getAttribute('data-group'));
      });

      if (brandBar && brands.length > 1) {
        brandBar.innerHTML = brands
          .map(function (candidate, index) {
            return (
              '<button type="button" class="mh-sg__tab" data-brand-key="' +
              esc(candidate.key) +
              '" aria-selected="' +
              (index === 0 ? 'true' : 'false') +
              '">' +
              esc(candidate.name) +
              '</button>'
            );
          })
          .join('');
        brandBar.addEventListener('click', function (event) {
          var tab = event.target.closest('[data-brand-key]');
          if (!tab) return;
          var next = brands.filter(function (candidate) {
            return candidate.key === tab.getAttribute('data-brand-key');
          })[0];
          if (next) showBrand(next);
        });
      }

      showBrand(brand);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }
})();
